// Envoi d'une correction d'un code SILAE généré par l'IA (le user a cliqué
// « Corriger le code », édité, puis enregistré). Le diff généré→final alimente
// l'apprentissage autonome du skill (seules les corrections des utilisateurs de
// confiance sont retenues côté serveur).

const API_BASE = `${import.meta.env.VITE_API_BASE_URL}/api/silae-corrections`;

export interface RecordCorrectionInput {
  generatedCode: string;
  finalCode: string;
  primeName?: string | null;
}

export const aiCorrectionService = {
  record: async (input: RecordCorrectionInput): Promise<void> => {
    const res = await fetch(API_BASE, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(input),
    });
    if (!res.ok) throw new Error("correction record failed");
  },
};
